import React, { FC } from "react";
import whiteCircle from "../../../../../../assets/whiteCircle.svg";
import cancellationReason from "../../../../../../assets/cancellationReason.svg";
import "./CancellationReason.scss";
import { IProposalCancellationReason } from "../../../../../../common/interfaces/proposals.interface";
const CancellationReason: FC<{
  cancelationReaason: IProposalCancellationReason;
  onCancellationChosen: (cancellationReason: number) => void;
  isActive?: boolean;
}> = ({ cancelationReaason, isActive, onCancellationChosen }) => {
  return (
    <div className="cancellation-reason">
      <img
        onClick={() => onCancellationChosen(cancelationReaason.id)}
        src={isActive ? cancellationReason : whiteCircle}
        alt="cancelationIcon"
      />
      <p>{cancelationReaason.label}</p>
    </div>
  );
};

export default CancellationReason;
